import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_TRANSPORT_LOADING = 'GET_TRANSPORT_LOADING';
export const GET_TRANSPORT_SUCCESS = 'GET_TRANSPORT_SUCCESS';
export const GET_TRANSPORT_REJECT = 'GET_TRANSPORT_REJECT';

//* ACTIONS ------------------------------------------------
export const getTransportLoading = () => ({ type: GET_TRANSPORT_LOADING });
export const getTransportSuccess = (payload) => ({ type: GET_TRANSPORT_SUCCESS, payload });
export const getTransportReject = (payload) => ({ type: GET_TRANSPORT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getTransportRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Providers/web/GetAllProviderTransports`, options);
};

